// Material Kit 2 React pages
import ProducstList from "presentation/components/ProductListPage";

export default function PorductListPage() {
  return <ProducstList />;
}
